import { ref } from 'vue';
import axios from 'axios';
import { FIELD_TYPE_LABELS } from '../constants/documentTypes';

// Usamos axios (no fetch) para beneficiarnos del interceptor JWT con
// auto-refresh de tokens y reintentos definido en main.js. Antes este
// composable usaba fetch directo, así que cuando caducaba el access
// token todas sus operaciones fallaban con 401 hasta recargar la página.
//
// NOTA: este proyecto usa @vue/cli-service ~4.5 con Babel sin presets
// modernos. Evitamos optional chaining (?.) y nullish coalescing (??)
// para que el build no falle.

const API_BASE_URL = process.env.VUE_APP_API_URL || '/api';

function extractError(e) {
  if (e && e.response && e.response.data && e.response.data.detail) {
    return e.response.data.detail;
  }
  return (e && e.message) ? e.message : String(e);
}

export function useFields() {
  const fields = ref([]);
  const loading = ref(false);
  const error = ref(null);

  const fetchFields = async () => {
    loading.value = true;
    error.value = null;
    try {
      const response = await axios.get(`${API_BASE_URL}/field-definitions/`);
      fields.value = response.data;
    } catch (e) {
      error.value = extractError(e);
      console.error('Error en fetchFields:', e);
    } finally {
      loading.value = false;
    }
  };

  const createField = async (fieldData) => {
    try {
      await axios.post(`${API_BASE_URL}/field-definitions/`, fieldData);
      await fetchFields();
      return true;
    } catch (e) {
      error.value = extractError(e);
      return false;
    }
  };

  const deleteField = async (id) => {
    try {
      await axios.delete(`${API_BASE_URL}/field-definitions/${id}/`);
      await fetchFields();
      return true;
    } catch (e) {
      error.value = extractError(e);
      return false;
    }
  };

  const formatTipo = (t) => FIELD_TYPE_LABELS[t] || 'Texto';

  return { fields, loading, error, fetchFields, createField, deleteField, formatTipo };
}
